import { cdnTemplate, jadeLocals } from 'cdnPreprocessor';

export default function ProductDisplay() {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      product: '=',
      storeRef: '='
    },
    template: require('./product-display.jade')(jadeLocals),
    link: (scope) => {
      scope.colorChangingMug = false;

      scope.$watch(() => scope.product, (p) => {
        if (typeof p == 'undefined' || !p) {
          scope.colorChangingMug = false;
          return;
        }
        scope.colorChangingMug = (p.render_type === 'COLOR_CHANGING_MUGS');
      });

      scope.changeView = (val) => {
        scope.storeRef.view = val;
        scope.storeRef.productGroups(true);
      }
    }
  }
};


// WEBPACK FOOTER //
// ./source/client/pages/store/product-display/product-display.dir.js